import { render } from "./settings-screen-header.vue?vue&type=template&id=27cf1a52&ts=true"
import script from "./settings-screen-header.ts?vue&type=script&lang=ts"
export * from "./settings-screen-header.ts?vue&type=script&lang=ts"

import "./settings-screen-header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__